import { handleRequest } from "../utilities/requestHandler";

export const createRole = (roleData) =>
    handleRequest("post", "/roles/create", roleData);

export const updateRole = (roleData) =>
    handleRequest("post", "/roles/update", roleData);